import React from "react";
import { CheckCircle, HelpCircle, FileQuestion, AlignLeft } from "lucide-react";
import { convertUtcToIst } from "util/Util";

export interface Training {
    trainingId: number;
    trainingName: string;
    domainName: string;
    lessonCount: number;
    exerciseCount: number;
    uploadedAt: string;
    trainingStatus: "PROCESSING" | "PENDING" | "GENERATING" | "READY" | "FAILED";
}

export interface Domain {
    id: number;
    domain: string;
    role?: string;
    focusArea?: string;
    itemHints?: string[];
    extraRules?: string;
}

export interface OptionProps {
    value: string;
    label: string;
}

export const formatTime = (dateStr: string) => {
    if (!dateStr) return "N/A";
    try {
        return convertUtcToIst(`${dateStr}Z`).full;
    } catch {
        return new Date(dateStr).toLocaleDateString();
    }
};

export const getStatusStyles = (status: string) => {
    switch (status) {
        case 'READY': return 'bg-green-100 text-green-700 dark:bg-green-900/30 dark:text-green-400';
        case 'PENDING': return 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-400';
        case 'PROCESSING':
        case 'GENERATING': return 'bg-yellow-100 text-yellow-700 dark:bg-yellow-900/30 dark:text-yellow-400';
        case 'FAILED': return 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-400';
        default: return 'bg-gray-200 text-gray-700 dark:bg-gray-600 dark:text-gray-300';
    }
};

export const getExerciseIcon = (type: string) => {
    switch (type) {
        case "mcq": return <HelpCircle size={16} className="text-blue-500" />;
        case "true_false": return <CheckCircle size={16} className="text-green-500" />;
        case "qa": return <AlignLeft size={16} className="text-purple-500" />;
        default: return <FileQuestion size={16} />;
    }
};